import { INDUSTRIES } from "../data/content";

export function EditorialMarquee() {
  const items = [...INDUSTRIES.map((i) => i.name), "Taxation", "Audit & Assurance", "GST Compliance", "Advisory"];
  const row = [...items, ...items];
  return (
    <div className="marquee-track relative overflow-hidden bg-navy border-y border-white/10 py-5" data-testid="editorial-marquee">
      <div className="marquee-inner flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-serif text-lg sm:text-xl text-slate-300 italic">{item}</span>
            <span className="w-1.5 h-1.5 rotate-45 bg-gold inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
}
